import React from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';

import ReserveDaysListFilter from './ListFilter';
import ReserveDaysListTable from './ListTable';
import ShowForPermission from '../../../components/ShowForPermission';
import Spin from '../../../components/loading';
import Pagination2 from '../../../components/Pagination2';

import * as reserveTimesActions from '../../../redux/reserveTimes/actions';
import ENUMS from '../../../enums';
import submitForm from '../../../utils/submitForm';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

class ReserveDaysManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      cafeIds: [],
      sortType: 'asc',
      sortBy: 'createdAt',
      itemsPerPage: 10,
      selectedCafeId: null,
    };
  }

  onSelectCafeIds = cafeIds =>
    this.setState({ cafeIds: cafeIds ? [...cafeIds] : [] });

  applyFilters = event => {
    const queryString = submitForm(
      event,
      this.state.selectedRegions,
      this.state.selectedAmenities,
      this.state.cafeIds,
    );
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  sortTable = query => {
    this.setState(
      { sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' },
      () => {
        query = `${query}-${this.state.sortType}`;
        this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
      },
    );
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      this.props.fetchAllReservationDays(searchQuery);
    });
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=date-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      this.props.fetchAllReservationDays(query);
    });
  };

  render() {
    let { loading, message, failed, error } = this.props;
    let { totalRecords } = this.props.reservationDays;
    let { currentPage, itemsPerPage, sortType } = this.state;

    return (
      <>
        {this.state.errorFlag &&
          AlertAndConfirmation({
            title: locales('titles.title'),
            text: '',
            type: 'error',
          })}
        <div className='col-12 d-flex justify-content-between align-items-center'>
          <h3 className='text-right text-muted py-4'>
            <div className='text-right'>
              {locales('titles.manage.reserve.days.and.hours')}
            </div>
          </h3>
          <div>
            {/* <ShowForPermission permission={ENUMS.PERMISSIONS.values.ADD_NEW_CAFE_DATE}>
              <NavLink
                to={{
                  pathname: '/reservation-days/add-or-edit',
                  editMode: false
                }}
              >
                <button className="btn btn-primary w-5 mx-1">
                  <i className="fal fa-plus mx-1" />
                  {locales('labels.newDay')}
                </button>
              </NavLink>
            </ShowForPermission> */}
            {/* <ShowForPermission permission={ENUMS.PERMISSIONS.values.AUTO_GENERATE_RESERVE_DATES_AND_HOURS}>
              <NavLink to="/reservation-days/auto-generate">
                <button className="btn btn-success w-5 mx-1">
                  <i className="fal fa-sync mx-1" />
                  {locales('labels.auto.generate')}
                </button>
              </NavLink>
            </ShowForPermission> */}
          </div>
        </div>
        <section className='p-1 col-12'>
          <Spin spinning={loading}>
            <article>
              <main className='panel panel-default'>
                {error ? (
                  <div className='alert alert-danger'>
                    {locales('messages.server.error')}
                  </div>
                ) : (
                  <>
                    {failed && (
                      <div className='alert alert-danger'>{message}</div>
                    )}
                    <ReserveDaysListFilter
                      applyFilters={this.applyFilters}
                      onSelectCafeIds={this.onSelectCafeIds}
                      filterAndSort={this.filterAndSort}
                      pageNumber={this.state.currentPage}
                    />
                    <div className='panel-heading'>
                      <i className='fas fa-list-alt px-1' />
                      {locales('titles.reservationDaysList')}
                    </div>
                    <div className='panel-body'>
                      <ReserveDaysListTable
                        pageNumber={currentPage}
                        pageSize={itemsPerPage}
                        sortTable={this.sortTable}
                        sortType={sortType}
                      />
                      <footer className='col-12 d-flex justify-content-center py-2'>
                        <div className='pagination-container'>
                          <Pagination2
                            totalRecords={totalRecords || 0}
                            pageLimit={itemsPerPage}
                            pageNeighbours={2}
                            onPageChanged={this.onPageChanged}
                            currentPage={this.state.currentPage}
                          />
                        </div>
                      </footer>
                    </div>
                  </>
                )}
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    reservationDaysList: state.reserveTimesReducer.reservationDaysList,
    reservationDays: state.reserveTimesReducer.reservationDays,
    loading: state.reserveTimesReducer.reservationDaysLoading,
    message: state.reserveTimesReducer.reservationDaysMessage,
    failed: state.reserveTimesReducer.reservationDaysFailed,
    error: state.reserveTimesReducer.reservationDaysError,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllReservationDays: query =>
      dispatch(reserveTimesActions.fetchAllReservationDays(query)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReserveDaysManagement),
);
